// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-enter {
  opacity: 0;
}

.modal-enter-active {
  opacity: 1;
  visibility: visible;
  transition: opacity 0.3s;
}

.modal-enter-done {
  opacity: 1;
  visibility: visible;
}

.modal-exit {
  opacity: 1;
}

.modal-exit-active {
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s;
}

.info-user {
  display: grid;
  gap: 1.875rem;
  align-items: start;
}
.info-user__image-ibg {
  padding-bottom: 80.5194805195%;
}
.info-user__image-ibg img {
  object-fit: contain;
  object-position: top;
}
.info-user__actions {
  display: flex;
  gap: 0.625rem;
}
@media (max-width: 47.99875em) {
  .info-user__actions {
    justify-content: center;
  }
}
.info-user__link {
  display: flex;
  border: 1px solid #007587;
  border-radius: 4px;
  padding: 0.625rem;
  transition: all 0.3s ease 0s;
}
@media (any-hover: hover) {
  .info-user__link:hover {
    background-color: #007587;
  }
  .info-user__link:hover .icon__user-mail,
  .info-user__link:hover .icon__user-download,
  .info-user__link:hover .icon__user-id {
    fill: #fff;
  }
}

.icon__user-mail {
  width: 0.9375rem;
  height: 0.9375rem;
  fill: #007587;
  transition: all 0.3s ease 0s;
}
.icon__user-download {
  width: 0.9375rem;
  height: 0.9375rem;
  fill: #007587;
  transition: all 0.3s ease 0s;
}
.icon__user-id {
  width: 0.9375rem;
  height: 0.9375rem;
  fill: #007587;
  transition: all 0.3s ease 0s;
}

.popup {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  padding: 30px 10px;
  z-index: 150;
  visibility: visible;
  overflow: auto;
  pointer-events: auto;
  backdrop-filter: blur(4px);
}
.popup__wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100%;
  flex: 1 1 auto;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.popup__content {
  background-color: #fff;
  padding: 15px;
  width: 100%;
  max-width: 992px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
  display: flex;
  gap: 1.25rem;
}
.popup__user-info {
  flex: 0 0 30%;
}
.popup__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 0.9375rem;
  border-bottom: 1px solid #e7e7e7;
}
.popup__title {
  font-weight: 700;
  font-size: 1.5rem;
  line-height: 0.75;
  color: #007587;
}
.popup__close {
  position: relative;
  width: 25px;
  height: 25px;
}
.popup__close::before, .popup__close::after {
  content: "";
  position: absolute;
  width: 1.5625rem;
  height: 0.1875rem;
  top: 50%;
  transform: translate(0px, -1.5px);
  left: 0;
  border-radius: 2.5rem;
  background-color: #119da4;
}
.popup__close::before {
  transform: rotate(-45deg);
}
.popup__close::after {
  transform: rotate(45deg);
}
.popup__body {
  flex: 1 1 auto;
  display: grid;
  gap: 0.9375rem;
  align-content: start;
}
.popup__info {
  margin-top: 0.9375rem;
  font-size: 16px;
  line-height: 24px;
}
.popup__info b {
  font-weight: 700;
}
.popup__info i {
  font-style: italic;
}
.popup__info u {
  text-decoration: underline;
}
.popup__info s {
  text-decoration: line-through;
}
.popup__info a {
  color: #007587;
  text-decoration: underline;
  transition: all 0.3s ease 0s;
}
@media (any-hover: hover) {
  .popup__info a:hover {
    color: rgb(0, 50.7, 58.5);
  }
}
.popup__button {
  margin-top: 0.9375rem;
  background-color: #119da4;
  color: #fff;
  width: 100%;
  padding: 0.6875rem;
  transition: all 0.3s ease 0s;
}
@media (any-hover: hover) {
  .popup__button:hover {
    background-color: #12bdc6;
  }
  .popup__button:active {
    background-color: #00767c;
  }
}

.error {
  color: red;
  font-size: 0.875rem;
  padding: 0.3125rem 0;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/components/landing/modal/modal.scss","webpack://./src/assets/scss/variables.scss"],"names":[],"mappings":"AAKA;EAGI,UAAA;AANJ;;AASA;EAGI,UAAA;EACA,mBAAA;EACA,wBAAA;AARJ;;AAWA;EAEI,UAAA;EAEA,mBAAA;AAVJ;;AAaA;EAEI,UAAA;AAXJ;;AAeA;EAEI,UAAA;EAEA,kBAAA;EACA,wBAAA;AAdJ;;AAmBA;EACI,aAAA;EACA,aAAA;EACA,kBAAA;AAhBJ;AAmBI;EAII,8BAAA;AApBR;AAsBQ;EACI,mBAAA;EACA,oBAAA;AApBZ;AAyBI;EACI,aAAA;EACA,aAAA;AAvBR;AAyBQ;EAJJ;IAKQ,uBAAA;EAtBV;AACF;AA0BI;EACI,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,4BAAA;AAxBR;AA0BQ;EACI;IACI,yBChFC;EDwDf;EA0Bc;;;IAGI,UAAA;EAxBlB;AACF;;AAgCI;EACI,gBAAA;EACA,iBAAA;EACA,aCjGS;EDkGT,4BAAA;AA7BR;AAiCI;EACI,gBAAA;EACA,iBAAA;EACA,aCzGS;ED0GT,4BAAA;AA/BR;AAmCI;EACI,gBAAA;EACA,iBAAA;EACA,aCjHS;EDkHT,4BAAA;AAjCR;;AAuCA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,0BAAA;AApCJ;AAuCI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AArCR;AAyCI;EACI,sBAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,sCAAA;EAEA,aAAA;EACA,YAAA;AAxCR;AA4CI;EACI,aAAA;AA1CR;AA8CI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,yBAAA;EACA,gCAAA;AA5CR;AAgDI;EACI,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cCjLS;ADmIjB;AAkDI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;AAhDR;AAkDQ;EAEI,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,QAAA;EACA,iCAAA;EACA,OAAA;EACA,qBAAA;EACA,yBAAA;AAjDZ;AAoDQ;EACI,yBAAA;AAlDZ;AAqDQ;EACI,wBAAA;AAnDZ;AAwDI;EACI,cAAA;EACA,aAAA;EACA,cAAA;EAEA,oBAAA;AAvDR;AA2DI;EACI,qBAAA;EACA,eAAA;EACA,iBAAA;AAzDR;AA2DQ;EACI,gBAAA;AAzDZ;AA4DQ;EACI,kBAAA;AA1DZ;AA6DQ;EACI,0BAAA;AA3DZ;AA8DQ;EACI,6BAAA;AA5DZ;AA+DQ;EACI,cChPK;EDiPL,0BAAA;EACA,4BAAA;AA7DZ;AA+DY;EACI;IACI,yBAAA;EA7DlB;AACF;AA+EI;EACI,qBAAA;EACA,yBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,4BAAA;AA7ER;AA+EQ;EACI;IACI,yBAAA;EA7Ed;EAgFU;IACI,yBAAA;EA9Ed;AACF;;AAmFA;EACI,UAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;AAhFJ","sourcesContent":["@use 'sass:math';\r\n@import '../../../assets/scss/variable-settings.scss';\r\n@import '../../../assets/scss/mixins.scss';\r\n@import '../../../assets/scss/variables.scss';\r\n\r\n.modal-enter {\r\n    // transform: translateY(-100%);\r\n    // transform: scale(0);\r\n    opacity: 0;\r\n}\r\n\r\n.modal-enter-active {\r\n    // transform: translateY(0);\r\n    // transform: scale(1);\r\n    opacity: 1;\r\n    visibility: visible;\r\n    transition: opacity 0.3s;\r\n}\r\n\r\n.modal-enter-done {\r\n    // transform: scale(1);\r\n    opacity: 1;\r\n    // transform: translateY(0);\r\n    visibility: visible;\r\n}\r\n\r\n.modal-exit {\r\n    // transform: scale(1);\r\n    opacity: 1;\r\n    // transform: translateY(0);\r\n}\r\n\r\n.modal-exit-active {\r\n    // transform: scale(0);\r\n    opacity: 0;\r\n    // transform: translateY(-100%);\r\n    visibility: hidden;\r\n    transition: opacity 0.3s;\r\n}\r\n\r\n//========================================================================================================================================================\r\n\r\n.info-user {\r\n    display: grid;\r\n    gap: rem(30);\r\n    align-items: start;\r\n\r\n    // .info-user__image-ibg\r\n    &__image-ibg {\r\n        // width: rem(325);\r\n        // height: rem(310);\r\n        // max-width: rem(300);\r\n        padding-bottom: percent(310, 385);\r\n\r\n        img {\r\n            object-fit: contain;\r\n            object-position: top;\r\n        }\r\n    }\r\n\r\n    // .info-user__actions\r\n    &__actions {\r\n        display: flex;\r\n        gap: rem(10);\r\n\r\n        @media (max-width: $mobile) {\r\n            justify-content: center;\r\n        }\r\n    }\r\n\r\n    // .info-user__link\r\n    &__link {\r\n        display: flex;\r\n        border: 1px solid #007587;\r\n        border-radius: 4px;\r\n        padding: rem(10);\r\n        transition: all 0.3s ease 0s;\r\n\r\n        @media (any-hover: hover) {\r\n            &:hover {\r\n                background-color: $mainBrandColor;\r\n\r\n                .icon__user-mail,\r\n                .icon__user-download,\r\n                .icon__user-id {\r\n                    fill: #fff;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.icon {\r\n    // .icon__user-mail\r\n    &__user-mail {\r\n        width: rem(15);\r\n        height: rem(15);\r\n        fill: $mainBrandColor;\r\n        transition: all 0.3s ease 0s;\r\n    }\r\n\r\n    // .icon__user-download\r\n    &__user-download {\r\n        width: rem(15);\r\n        height: rem(15);\r\n        fill: $mainBrandColor;\r\n        transition: all 0.3s ease 0s;\r\n    }\r\n\r\n    // .icon__user-id\r\n    &__user-id {\r\n        width: rem(15);\r\n        height: rem(15);\r\n        fill: $mainBrandColor;\r\n        transition: all 0.3s ease 0s;\r\n    }\r\n}\r\n\r\n//========================================================================================================================================================\r\n\r\n.popup {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    bottom: 0;\r\n    right: 0;\r\n    padding: 30px 10px;\r\n    z-index: 150;\r\n    visibility: visible;\r\n    overflow: auto;\r\n    pointer-events: auto;\r\n    backdrop-filter: blur(4px);\r\n\r\n    // .popup__wrapper\r\n    &__wrapper {\r\n        display: flex;\r\n        flex-direction: column;\r\n        align-items: center;\r\n        min-height: 100%;\r\n        flex: 1 1 auto;\r\n        width: 100%;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n    }\r\n\r\n    // .popup__content\r\n    &__content {\r\n        background-color: #fff;\r\n        padding: 15px;\r\n        width: 100%;\r\n        max-width: 992px;\r\n        box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);\r\n\r\n        display: flex;\r\n        gap: rem(20);\r\n    }\r\n\r\n    // .popup__user-info\r\n    &__user-info {\r\n        flex: 0 0 30%;\r\n    }\r\n\r\n    // .popup__header\r\n    &__header {\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n        padding-bottom: rem(15);\r\n        border-bottom: 1px solid #e7e7e7;\r\n    }\r\n\r\n    // .popup__title\r\n    &__title {\r\n        font-weight: 700;\r\n        font-size: rem(24);\r\n        line-height: math.div(18, 24);\r\n        color: $mainBrandColor;\r\n    }\r\n\r\n    // .popup__close\r\n    &__close {\r\n        position: relative;\r\n        width: 25px;\r\n        height: 25px;\r\n\r\n        &::before,\r\n        &::after {\r\n            content: '';\r\n            position: absolute;\r\n            width: rem(25);\r\n            height: rem(3);\r\n            top: 50%;\r\n            transform: translate(0px, -1.5px);\r\n            left: 0;\r\n            border-radius: rem(40);\r\n            background-color: #119da4;\r\n        }\r\n\r\n        &::before {\r\n            transform: rotate(-45deg);\r\n        }\r\n\r\n        &::after {\r\n            transform: rotate(45deg);\r\n        }\r\n    }\r\n\r\n    // .popup__body\r\n    &__body {\r\n        flex: 1 1 auto;\r\n        display: grid;\r\n        gap: rem(15);\r\n        // align-items: start;\r\n        align-content: start;\r\n    }\r\n\r\n    // .popup__info\r\n    &__info {\r\n        margin-top: rem(15);\r\n        font-size: 16px;\r\n        line-height: 24px;\r\n\r\n        b {\r\n            font-weight: 700;\r\n        }\r\n\r\n        i {\r\n            font-style: italic;\r\n        }\r\n\r\n        u {\r\n            text-decoration: underline;\r\n        }\r\n\r\n        s {\r\n            text-decoration: line-through;\r\n        }\r\n\r\n        a {\r\n            color: $mainBrandColor;\r\n            text-decoration: underline;\r\n            transition: all 0.3s ease 0s;\r\n\r\n            @media (any-hover: hover) {\r\n                &:hover {\r\n                    color: darken($color: $mainBrandColor, $amount: 15);\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    // .popup__currence\r\n    &__currence {\r\n    }\r\n\r\n    // .popup__amount\r\n    &__amount {\r\n    }\r\n\r\n    // .popup__input\r\n    &__input {\r\n    }\r\n\r\n    // .popup__button\r\n    &__button {\r\n        margin-top: rem(15);\r\n        background-color: #119da4;\r\n        color: #fff;\r\n        width: 100%;\r\n        padding: rem(11);\r\n        transition: all 0.3s ease 0s;\r\n\r\n        @media (any-hover: hover) {\r\n            &:hover {\r\n                background-color: #12bdc6;\r\n            }\r\n\r\n            &:active {\r\n                background-color: #00767c;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.error {\r\n    color: red;\r\n    font-size: rem(14);\r\n    padding: rem(5) 0;\r\n    text-align: center;\r\n}\r\n","$mainBrandColor: #007587;\r\n$mainBgGrey: #F0F8F2;\r\n$mainHoverButtonColor: #EDF5F6;\r\n$mainDarkGreen: #003300;\r\n$mainLightBlue: #92DCE5;\r\n\r\n$mainCardTextDarkGrey: #787878;\r\n$mainCardDateGrey: #A8A8A8;\r\n$mainCardTagDarkGrey: #6A6A6A;\r\n$mainLightGrey: #f6f6f6;\r\n$mainCardButtonDark: #383D3B;\r\n$mainSubtitleDarkGrey: #A9A9A9;\r\n$mainDarkCyan: #119DA4;\r\n$mainDarkenDarkCyan: #0082ca;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
